var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._t("default"),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.hide_paginate && _vm.registros.last_page > 1,
              expression: "!hide_paginate && registros.last_page > 1",
            },
          ],
          attrs: { id: "paginate-" + _vm.id_request },
        },
        [
          _c(
            "div",
            { staticClass: "d-flex justify-content-end" },
            [
              _c("paginate", {
                attrs: { id_paginate: _vm.id_request },
                on: {
                  buscarPagina: function ($event) {
                    return _vm.pagina($event)
                  },
                },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _vm.carregando
        ? _c("div", { staticClass: "row" }, [
            _c(
              "div",
              {
                staticClass:
                  "text-center col d-flex align-items-center justify-content-center py-3",
              },
              [
                _c("hollow-dots-spinner", {
                  key: "loading-" + _vm.id_request,
                  attrs: {
                    "animation-duration": 1000,
                    "dot-size": 10,
                    "dots-num": 3,
                    color: "#6F787D",
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }